import api from './api'

const formService = {
  // PUBLIC
  async getBySlug(slug) {
    const response = await api.get(`/forms/slug/${slug}`)
    return response.data
  },
  async submit(slug, values, tracking) {
    const response = await api.post(`/forms/slug/${slug}/submit`, { values, tracking })
    return response.data
  },
  async upload(file, kind = 'cv') {
    const fd = new FormData()
    fd.append('file', file)
    const response = await api.post(`/forms/upload?kind=${kind}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  // ADMIN
  async list() {
    const response = await api.get('/forms')
    return response.data
  },
  async get(id) {
    const response = await api.get(`/forms/${id}`)
    return response.data
  },
  async create(data) {
    const response = await api.post('/forms', data)
    return response.data
  },
  async update(id, data) {
    const response = await api.put(`/forms/${id}`, data)
    return response.data
  },
  async remove(id) {
    const response = await api.delete(`/forms/${id}`)
    return response.data
  },
  async saveFields(id, fields) {
    const response = await api.put(`/forms/${id}/fields`, { fields })
    return response.data
  },
}

// Catalog loại trường (cho builder)
export const FIELD_TYPES = [
  { value: 'text', label: 'Văn bản ngắn' },
  { value: 'textarea', label: 'Văn bản dài' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Số điện thoại' },
  { value: 'number', label: 'Số' },
  { value: 'date', label: 'Ngày' },
  { value: 'select', label: 'Chọn 1 (dropdown)' },
  { value: 'multiselect', label: 'Chọn nhiều' },
  { value: 'boolean', label: 'Có / Không' },
  { value: 'file', label: 'Tải file (CV...)' },
  { value: 'image', label: 'Tải ảnh' },
  { value: 'url', label: 'Liên kết (URL)' },
]

export const FIELD_TYPE_LABELS = FIELD_TYPES.reduce((a, t) => { a[t.value] = t.label; return a }, {})

// Trường hệ thống (map cột lead) — để builder gợi ý thêm nhanh
export const SYSTEM_FIELDS = [
  { field_key: 'full_name', label: 'Họ và tên', field_type: 'text' },
  { field_key: 'email', label: 'Email', field_type: 'email' },
  { field_key: 'birth_year', label: 'Năm sinh', field_type: 'number' },
  { field_key: 'current_location', label: 'Nơi ở hiện tại', field_type: 'text' },
  { field_key: 'desired_area', label: 'Khu vực làm việc', field_type: 'select' },
  { field_key: 'position', label: 'Vị trí ứng tuyển', field_type: 'select' },
  { field_key: 'experience', label: 'Kinh nghiệm', field_type: 'select' },
  { field_key: 'source', label: 'Nguồn', field_type: 'select' },
  { field_key: 'note', label: 'Ghi chú / Lời nhắn', field_type: 'textarea' },
  { field_key: 'cv', label: 'CV đính kèm', field_type: 'file' },
]

// system select nào lấy option từ FormOption (category)
export const SYSTEM_SELECT_CATEGORY = {
  desired_area: 'work_area',
  position: 'position',
  experience: 'experience',
  source: 'source',
}

export default formService
